import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../artzu-ui/src/Button';

const FailedButtonGroup = ({ retakeExam }) => (
  <div className="new-exam__body__results__buttons">
    {/* <button className="course-section_button" onClick={retakeExam}>
      TRY AGAIN
    </button> */}
    <Link to="/newcourse">
      {/* <button className="course-section_button">REVIEW</button> */}
      <Button padding="0" color="#414141" label="Course" size="xl" />
    </Link>
    <Button
      padding="0"
      color="#128DFF"
      label="Try Again"
      size="xl"
      onClick={retakeExam}
    />
  </div>
);

export default FailedButtonGroup;



// WEBPACK FOOTER //
// ./src/components/NewExam/FailedButtonGroup.js